module.exports = __webpack_public_path__ + "static/media/step1.e0316ee5.png";